import React from 'react';
import { Container } from '../components/common/Container';
import { Card } from '../components/common/Card';
import { CheckIcon } from '@heroicons/react/24/outline';

export const About: React.FC = () => {
  const values = [
    {
      title: 'Data-Driven Decisions',
      description: 'We believe in the power of accurate data and proven methodologies to win appeals.'
    },
    {
      title: 'Professional Excellence',
      description: 'Built for tax professionals, by people who understand the appeal process.'
    },
    {
      title: 'Innovation & Automation',
      description: 'Continuously improving our platform to save you time and increase success rates.'
    },
    {
      title: 'Client Success',
      description: 'Your success is our success. We\'re committed to helping you win every appeal.'
    }
  ];
  
  return (
    <>
      {/* Hero Section */}
      <section className="bg-brand-blue py-20">
        <Container>
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              About Appeal Advantage
            </h1>
            <p className="text-xl text-brand-blue-100">
              We're transforming property tax appeals with software that combines
              powerful automation with professional-grade tools.
            </p>
          </div>
        </Container>
      </section>
      
      {/* Mission Section */}
      <section className="py-24 bg-white">
        <Container>
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-brand-blue mb-6">
                Our Mission
              </h2>
              <p className="text-lg text-brand-white-700 mb-4">
                Appeal Advantage was built to level the playing field for property
                tax professionals. Whether you're a boutique firm or an enterprise
                operation, you deserve access to powerful tools that streamline
                your workflow and increase your success rates.
              </p>
              <p className="text-lg text-brand-white-700">
                We combine comprehensive valuation methodologies, intelligent automation,
                and enterprise-grade API integration to help you manage more properties,
                win more appeals, and serve more clients—all from one unified platform.
              </p>
            </div>
            <div className="bg-brand-blue-50 p-8 rounded-lg">
              <div className="space-y-4">
                <div className="flex items-start">
                  <CheckIcon className="w-6 h-6 text-brand-red mr-3 mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="font-bold text-brand-blue mb-1">All-in-One Platform</h3>
                    <p className="text-brand-white-700">Replace multiple expensive tools with one comprehensive solution.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckIcon className="w-6 h-6 text-brand-red mr-3 mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="font-bold text-brand-blue mb-1">Professional Grade</h3>
                    <p className="text-brand-white-700">Court-ready documentation and industry-standard methodologies.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckIcon className="w-6 h-6 text-brand-red mr-3 mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="font-bold text-brand-blue mb-1">Built for Scale</h3>
                    <p className="text-brand-white-700">From 100 properties to 100,000, our platform grows with you.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
      
      {/* Values Section */}
      <section className="py-24 bg-brand-blue-50">
        <Container>
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-brand-blue mb-4">
              Our Values
            </h2>
            <p className="text-xl text-brand-white-600 max-w-3xl mx-auto">
              The principles that guide everything we do
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            {values.map((value, index) => (
              <Card key={index}>
                <h3 className="text-xl font-bold text-brand-blue mb-3">
                  {value.title}
                </h3>
                <p className="text-brand-white-700">
                  {value.description}
                </p>
              </Card>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
};

